import { useDebounce } from "../timing/useDebounce";
import { useFuzzySearch } from "./useFuzzySearch";

/**
 * Hook de recherche fuzzy avec debounce intégré
 *
 * @template T
 *
 * @param {T[]} items Liste des éléments à rechercher
 * @param {string} query Texte saisi par l'utilisateur
 * @param {Object} options
 * @param {number} [options.debounceMs=150] Délai du debounce en millisecondes (150ms par défaut)
 *
 * Les autres options sont transmises à useFuzzySearch
 *
 * @returns {Array<{item: T, refIndex: number, score?: number, matches?: Array}>}
 */
export const useDebouncedFuzzySearch = (items, query, options = {}) => {
	const { debounceMs = 150, ...rest } = options;

	const debouncedQuery = useDebounce(query, debounceMs);

	return useFuzzySearch(items, debouncedQuery, rest);
};
